import { Ref, ref } from "vue";

export interface OnlineAnswersheetAttachment {
  id: string;
  title: string;
  file_size: number;
  file_path: string;
}

export const useOnlineAnswersheetAttachments = () => {
  const isOnlineAnswersheetAttachmentsDialogVisible = ref(false);
  const attachments: Ref<OnlineAnswersheetAttachment[]> = ref([]);

  const onAttachmentAdded = (attachment: OnlineAnswersheetAttachment) => {
    attachments.value.push(attachment);

    //Show the dialog again
    isOnlineAnswersheetAttachmentsDialogVisible.value = true;
  };

  const onAttachmentRemoved = (id: string) => {
    const index = attachments.value.findIndex(
      (attachment) => attachment.id === id
    );

    if (index !== -1) {
      attachments.value.splice(index, 1);
    }
  };

  return {
    onAttachmentAdded,
    isOnlineAnswersheetAttachmentsDialogVisible,
    attachments,
    onAttachmentRemoved,
  };
};
